function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.2 10.1h-5.3V4.8c0-.5-.4-.9-.9-.9s-.9.4-.9.9v5.3H4.8c-.5 0-.9.4-.9.9s.4.9.9.9h5.3v5.3c0 .5.4.9.9.9s.9-.4.9-.9v-5.3h5.3c.5 0 .9-.4.9-.9s-.4-.9-.9-.9z"
});
function SvgPlusSmall2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref);
}
export default SvgPlusSmall2;